var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPewFollowerIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 81,
    height: 80,
    viewBox: "0 0 81 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2407_19299)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M40.5 80C62.5914 80 80.5 62.0914 80.5 40C80.5 17.9086 62.5914 0 40.5 0C18.4086 0 0.5 17.9086 0.5 40C0.5 62.0914 18.4086 80 40.5 80Z",
    fill: "#EAECF0"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 17,
    y: 21,
    width: 46,
    height: 59,
    rx: 7,
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M40 53C46.6274 53 52 47.6274 52 41C52 34.3726 46.6274 29 40 29C33.3726 29 28 34.3726 28 41C28 47.6274 33.3726 53 40 53Z",
    fill: "#47AD1D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.9978 43.1162C37.1225 43.1162 34.6665 43.5695 34.6665 45.3829C34.6665 47.1969 37.1072 47.6662 39.9978 47.6662C42.8732 47.6662 45.3292 47.2135 45.3292 45.3995C45.3292 43.5855 42.8892 43.1162 39.9978 43.1162Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.9977 41.389C41.9564 41.389 43.5257 39.819 43.5257 37.861C43.5257 35.903 41.9564 34.333 39.9977 34.333C38.0397 34.333 36.4697 35.903 36.4697 37.861C36.4697 39.819 38.0397 41.389 39.9977 41.389Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.4062 58H33.5938C32.7135 58 32 58.7156 32 59.5984C32 60.4811 32.7135 61.1968 33.5938 61.1968H47.4062C48.2865 61.1968 49 60.4811 49 59.5984C49 58.7156 48.2865 58 47.4062 58Z",
    fill: "#EAECF0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.44 64.3936H28.56C27.6984 64.3936 27 65.1092 27 65.9919C27 66.8747 27.6984 67.5903 28.56 67.5903H51.44C52.3016 67.5903 53 66.8747 53 65.9919C53 65.1092 52.3016 64.3936 51.44 64.3936Z",
    fill: "#EAECF0"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2407_19299"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    width: 80,
    height: 80,
    rx: 40,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPewFollowerIcon);
export default __webpack_public_path__ + "static/media/pew-follower-icon.9c60a98446468646069ab927150fd623.svg";
export { ForwardRef as ReactComponent };